import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../../components/Layout/Layout";
import DiscountHubService from "../../../services/DiscountHubService";
import { HollowDotsSpinner } from "react-epic-spinners";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import fire from "../../../utils/Toastr";

export default function CreateReferralCode() {
  const navigate = useNavigate();
  const user = sessionStorage.getItem("user");
  let createdBy = "admin";
  try {
    if (user) {
      const userObj = JSON.parse(user);
      createdBy = userObj.userName || userObj.email || "admin";
    }
  } catch (e) {
    // ignore
  }

  const [formValues, setFormValues] = useState({
    referralCode: "",
    referralName: "",
    referralAmount: "",
    createdBy: createdBy,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        ...formValues,
        referralAmount: parseFloat(formValues.referralAmount) || 0,
      };
      const resp = await DiscountHubService.createReferralCode(payload);
      if (resp && resp.status !== false) {
        fire("success", resp.message || "Referral code created successfully");
        navigate("/discount-hub/referral-codes");
      } else {
        fire("error", resp?.message || "Failed to create referral code");
      }
    } catch (error) {
      console.error("Error creating referral code:", error);
      fire("error", "Failed to create referral code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Create Referral Code" pageTag="discount-hub" current="/discount-hub/referral-codes">
      <React.Fragment>
        <main>
          <div className="max-w-3xl mx-auto">
            <div className="mb-6">
              <Link
                to="/discount-hub/referral-codes"
                className="inline-flex items-center text-sm text-red-600 hover:text-red-500"
              >
                <ArrowLeftIcon className="h-4 w-4 mr-1" />
                Back to Referral Codes
              </Link>
            </div>

            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-4 border-b border-gray-200">
                <h2 className="text-lg font-medium text-gray-900">
                  Create Referral Code
                </h2>
              </div>
              <form onSubmit={handleSubmit} className="px-6 py-6 space-y-6">
                <div>
                  <label
                    htmlFor="referralCode"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Referral Code
                  </label>
                  <input
                    type="text"
                    name="referralCode"
                    id="referralCode"
                    required
                    value={formValues.referralCode}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    placeholder="e.g., PTB001"
                  />
                </div>

                <div>
                  <label
                    htmlFor="referralName"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Referral Name
                  </label>
                  <input
                    type="text"
                    name="referralName"
                    id="referralName"
                    required
                    value={formValues.referralName}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    placeholder="e.g., Becon Daniel"
                  />
                </div>

                <div>
                  <label
                    htmlFor="referralAmount"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Referral Amount
                  </label>
                  <input
                    type="number"
                    name="referralAmount"
                    id="referralAmount"
                    required
                    value={formValues.referralAmount}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-red-500 focus:border-red-500 sm:text-sm"
                    placeholder="0"
                  />
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <Link
                    to="/discount-hub/referral-codes"
                    className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    disabled={loading}
                    className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-60"
                  >
                    {loading ? (
                      <HollowDotsSpinner size={12} color="#FFFFFF" className="mr-2" />
                    ) : null}
                    {loading ? "Creating..." : "Create Referral Code"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </React.Fragment>
    </Layout>
  );
}
